import { Bars } from 'react-loader-spinner';
import MachinesMonitorTable from '../../components/tables/MachinesMonitorTable';
import { useQueues } from '../../features/jobs/queues/hooks/useQueues.js';
import { Col, Row } from 'react-bootstrap';

const MachineQueues = () => {
  const { data, isLoading, isFetching, error } = useQueues();

  if (isLoading)
    return (
      <Bars
        height="80"
        width="80"
        radius="9"
        color={'#3874ff'}
        ariaLabel="three-dots-loading"
        wrapperStyle={styles.spinnerContainer}
      />
    );
  const { currentShift, queue } = data;

  return (
    <div>
      <h3>Machines</h3>
      <p className="text-700 lh-sm mb-4">Brief summary of all machines</p>
      <MachinesMonitorTable queue={queue} />
    </div>
  );
};

const styles = {
  spinnerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Optional: Add a background with some opacity
    zIndex: 1000 // Ensure the spinner is on top
    // backgroundColor: '#000', // Optional: background color
  }
};

export default MachineQueues;
